function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import * as _ from 'lodash-es';
import React from 'react';
import { Image as RNImage, Animated, StyleSheet, View, Platform } from 'react-native';
import { BlurView } from 'expo-blur';
import CacheManager from "./CacheManager";
export default class Image extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "mounted", true);

    _defineProperty(this, "state", {
      uri: undefined,
      intensity: new Animated.Value(100)
    });
  }

  componentDidMount() {
    this.load(this.props);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      preview,
      transitionDuration,
      uri: newURI
    } = this.props;
    const {
      uri,
      intensity
    } = this.state;

    if (newURI !== prevProps.uri) {
      this.load(this.props);
    } else if (uri && preview && prevState.uri === undefined) {
      Animated.timing(intensity, {
        duration: transitionDuration,
        toValue: 0,
        useNativeDriver: Platform.OS === 'android'
      }).start();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  async load({
    uri,
    options = {},
    onError
  }) {
    if (uri) {
      try {
        const path = await CacheManager.get(uri, options).getPath();

        if (this.mounted) {
          if (path) {
            this.setState({
              uri: path
            });
          } else {
            onError({
              nativeEvent: {
                error: new Error('Could not load image')
              }
            });
          }
        }
      } catch (error) {
        onError({
          nativeEvent: {
            error
          }
        });
      }
    }
  }

  render() {
    const _this$props = this.props,
          {
      preview,
      style,
      defaultSource,
      tint
    } = _this$props,
          otherProps = _objectWithoutProperties(_this$props, ["preview", "style", "defaultSource", "tint"]);

    const {
      uri,
      intensity
    } = this.state;
    const isImageReady = !!uri;
    const opacity = intensity.interpolate({
      inputRange: [0, 100],
      outputRange: [0, 0.5]
    });
    const flattenedStyle = StyleSheet.flatten(style);
    const computedStyle = [StyleSheet.absoluteFill, _.transform(_.pickBy(flattenedStyle, (_val, key) => propsToCopy.indexOf(key) !== -1), (result, value, key) => Object.assign(result, {
      [key]: value - (flattenedStyle.borderWidth || 0)
    }))];
    return /*#__PURE__*/React.createElement(View, {
      style
    }, !!defaultSource && !isImageReady && /*#__PURE__*/React.createElement(RNImage, _extends({
      source: defaultSource,
      style: computedStyle
    }, otherProps)), !!preview && /*#__PURE__*/React.createElement(RNImage, _extends({
      source: preview,
      style: computedStyle,
      blurRadius: Platform.OS === 'android' ? 0.5 : 0
    }, otherProps)), isImageReady && /*#__PURE__*/React.createElement(RNImage, _extends({
      source: {
        uri
      },
      style: computedStyle
    }, otherProps)), !!preview && Platform.OS === 'ios' && /*#__PURE__*/React.createElement(AnimatedBlurView, _extends({
      style: computedStyle
    }, {
      intensity,
      tint
    })), !!preview && Platform.OS === 'android' && /*#__PURE__*/React.createElement(Animated.View, {
      style: [computedStyle, {
        backgroundColor: tint === 'dark' ? black : white,
        opacity
      }]
    }));
  }

}

_defineProperty(Image, "defaultProps", {
  transitionDuration: 300,
  tint: 'dark',
  onError: () => {}
});

const black = 'black';
const white = 'white';
const propsToCopy = ['borderRadius', 'borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'];
const AnimatedBlurView = Animated.createAnimatedComponent(BlurView);